import { AbstractApiModel } from '@ng-cloud/badger-core/models/abstract-api-model';

export class ScanConfig extends AbstractApiModel<ScanConfig> {
  name: string;
  description: string;
  organizationId: number;
  storeId: number;
  solution: string;
  configType: string;
  priority: number;
  settings: any = {};
  updatedById: number;

  deserialize(json: any): this {
    this.name = json.name;
    this.description = json.description;
    this.organizationId = json.organization_id;
    this.storeId = json.store_id;
    this.solution = json.solution;
    this.configType = json.config_type;
    this.priority = json.priority;
    this.settings = json.settings;
    this.updatedById = json.updated_by_id;
    return super.deserialize(json);
  }

  serialize(): any {
    return Object.assign(super.serialize(), {
      name: this.name,
      description: this.description,
      organization_id: this.organizationId,
      store_id: this.storeId,
      solution: this.solution,
      config_type: this.configType,
      priority: this.priority,
      settings: this.settings
    });
  }


}
